import { useSelector } from "react-redux";
export const useDD = () => {
  const dropDowns = useSelector((state) => state.ddData);
  return [dropDowns];
};
